<template>
    <LoadingScreen/>
    <BackgroundStars/>
    <MessageBox/>

    <div class="app-content-wrapper" v-if="isMobileDevice">
        <router-view/>
    </div>
</template>

<script>
import BackgroundStars from "@/components/BackgroundStars.vue";
import LoadingScreen from "@/components/Loading/LoadingScreen.vue";
import MessageBox from "@/components/MessageBox.vue";
import {Profile} from "@/store";
import {mapStores} from "pinia";

export default {
    components: {
        BackgroundStars,
        LoadingScreen,
        MessageBox
    },

    data() {
        return {
            isMobileDevice: this.isMobile()
        }
    },

    computed: {
        ...mapStores(Profile)
    },

    async created() {
        // if (false)
        // this.Profile.update({
        //     is_onboarding_completed: false
        // });


        if (!this.isMobileDevice) {
            this.$MessageBox.show({
                message: 'Daha iyi bir kullanıcı deneyimi sunmak için KAHIN AI sadece mobil cihazlar ile uyumludur.',
            });
        }

        const that = this;
        window.addEventListener('popstate', function (event) {
            if (that.$Loading.isLoading) {
                that.$Loading.hide();
            }
            if (that.$MessageBox.shown) {
                that.$MessageBox.hide();
            }
        });

        const autoLoginToken = (new URLSearchParams(window.location.search))?.get('autoLoginToken');
        if (autoLoginToken) {
            this.$Loading.show();
            const autoLoginResponse = await this.$api.post('/autoLogin', {
                auto_login_token: autoLoginToken
            });

            // check response status
            if (autoLoginResponse.status !== 200) {
                this.$MessageBox.show({
                    message: 'Giriş yapılamadı. Bilgilerini kontrol edip tekrar dener misin?',
                    buttonAction: () => window.location.href = '/login'
                });
                this.$Loading.hide();

                return false;
            }

            const spicaToken = autoLoginResponse.data?.spica_token;
            const user = autoLoginResponse.data?.user;

            // check spica token
            if (!spicaToken) {
                this.$MessageBox.show({
                    message: 'Giriş yapılamadı. Bilgilerini kontrol edip tekrar dener misin?',
                    buttonAction: () => window.location.href = '/login'
                });
                this.$Loading.hide();

                return false;
            }

            const spicaUserObject = JSON.stringify({
                token: spicaToken,
                ...user
            });

            localStorage.setItem('userId', user._id);
            localStorage.setItem('_profile', spicaUserObject);

            // console.log(user.is_onboarding_completed);

            // this.$router.push(user.is_onboarding_completed ? '/personalization/1': '/predictions');
            // window.location.href = user.is_onboarding_completed ? '/personalization/1': '/predictions';
            window.location.href = user.is_onboarding_completed ? '/': '/predictions';


            // console.log('spicaUserObject', user);

            // await this.Profile.setUserObject({
            //     token: spicaToken,
            //     ...user
            // });



            // // console.log('spicaToken', spicaToken);
            // // console.log('user', user);
            //
            // // const upRes = await this.$api.put('/user-update', {
            // //     token: spicaToken,
            // //     is_onboarding_completed: true
            // // });
            // //
            // // console.log('upRes', upRes);
            // localStorage.setItem('userId', user._id);
            // localStorage.setItem('_profile', JSON.stringify({
            //     token: spicaToken,
            //     // is_onboarding_completed: true,
            //     ...user
            // }));
            //
            // // Sync store and mark onboarding completed, then navigate to predictions
            // // await this.Profile.get();
            // // this.Profile.is_onboarding_completed = true;
            // await this.Profile.saveLocalStorage();
            //
            // this.$Loading.hide();
            //
            //
            // console.log(
            //     '>>> Profile >>>',
            //     JSON.parse(localStorage.getItem('_profile')).first_name
            // )
            //
            // // this.$router.replace('/predictions');
            // // this.$router.replace('/personalization/1');

        }

    },

    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true;
            }
            return false;
        }
    }
}
</script>

<style>
.app-content-wrapper {
    width: 100%;
    position: absolute;
    top: 80px;
    z-index: 1;
}
</style>
